import scriptjs from 'scriptjs';
import {autobind} from 'core-decorators';
import {getDOMNode, getDOMNodes} from 'utils';
import BaseAdapter from './base';

export const loadScript = scriptjs;

// http://knowledge.vidyard.com/Support_Topics/Developer_Center/How_to_use_the_Vidyard_Player_API

@autobind
export default class VidyardAdapter extends BaseAdapter {
    static findVideos() {
        const nodes = getDOMNodes('script[id^="vidyard_embed_code"]');
        return nodes.map(script => {
            const id = script.id.split('_')[3];
            return {
                provider: 'vidyard',
                videoId: id,
                videoNode: getDOMNode(`span[id^='vidyard_span_${id}']`),
                entryNode: script,
            };
        });
    }

    prepareVideoNode() {
        this.videoNode.style.margin = 0;
    }

    loadAPI() {
        return new Promise((resolve, reject) => {
            const apiURL = 'https://play-staging.vidyard.com/v0/api.js';
            const check = () => {
                const videoNode = getDOMNode(`iframe[id^='vidyard_iframe_${this.videoId}']`);
                if (window.Vidyard && window.Vidyard.players && videoNode) {
                    this.videoNode = videoNode;
                    resolve();
                } else {
                    setTimeout(check, BaseAdapter.CHECK_INTERVAL);
                }
            };

            if (!getDOMNode(`script[src="${apiURL}"]`)) exports.loadScript(apiURL, check);
            else check();

            const timeout = () => reject('Vidyard Player API failed to load');
            setTimeout(timeout, BaseAdapter.API_TIMEOUT);
        });
    }

    attach() {
        return new Promise((resolve, reject) => {
            this.api = new window.Vidyard.player(this.videoId);

            if (!this.api.iframe) return reject('Vidyard Player initialization failed (missing iframe)');

            this.api.on('timeupdate', this.syncPlayhead);
            this.api.on('pause', () => this.setPlayerState(BaseAdapter.STATES.Paused));
            this.api.on('play', () => this.setPlayerState(BaseAdapter.STATES.Playing));
            this.api.on('chapterComplete', () => this.setPlayerState(BaseAdapter.STATES.Ended));
            this.api.on('ready', () => {
                this.handleReady();
                resolve();
            });

            const timeout = () => reject('Vidyard Player initialization failed');
            setTimeout(timeout, BaseAdapter.API_TIMEOUT);
        });
    }

    handleReady() {
        this.setDuration(this.getDuration());
        this.api.disableCaption();
    }

    syncPlayhead(seconds) {
        this.setPlayhead(this.toMS(seconds));
    }

    seek(time) {
        this.api.seek(this.toSS(time));
    }

    pause() {
        this.api.pause();
    }

    getVideoAttributes() {
        return this.api.metadata.chapters_attributes[0].video_attributes;
    }

    getDuration() {
        return this.toMS(this.api.metadata.length_in_seconds);
    }

    getCurrentTime() {
        return this.api.currentTime();
    }

    getVideoTitle() {
        return Promise.resolve(this.getVideoAttributes().name);
    }

    getMetadata() {
        const {
            name,
            description,
            hd_url: contentUrl,
            thumbnail_urls: {normal, small},
        } = this.getVideoAttributes();

        return {
            name,
            contentUrl,
            description,
            thumbnailUrl: normal || small,
            uploadDate: new Date().toISOString(),
        };
    }
}



// WEBPACK FOOTER //
// ./scripts/adapters/vidyard.js